export default {
  key1: 'Este es el mensaje 1', // basic
  nested: {
    // nested
    message1: 'Este es el mensaje anidado 1',
  },
  Month: 'Mes',
  Type: 'Tipo',
  File: 'Fichero',
  'issued-invoice': 'Factura emitida',
  'received-invoice': 'Factura recibida',
  'Created at': 'Fecha Creación',
  Status: 'Estado',
  Category: 'Categoría',
  uncontabilized: 'Sin contabilizar',
  contabilized: 'Contabilizado',
  in_process: 'En proceso',
  attached: 'Adjunto',
  error: 'Con errores',
  active: 'activo',
  others: 'Bancos',
  undefined: 'Sin definir',
  FAC: 'Facturas emitidas',
  RFAC: 'Facturas recibidas',
  PYG: 'Pérdidas y Ganancias',
  SITUACION: 'Balance de situación',
  SUMASYSALDOS: 'Sumas y Saldos',
  submit: 'Enviar',
  dismiss: 'Cancelar',
  Submit: 'Enviar',
  Consultant: 'Asesor',
  consultant: 'asesor',
  Consultants: 'Asesores',
  consultants: 'asesores',
  confirmed: 'Confirmado',
  in_progress: 'Sin confirmar',
  Close: 'Cerrar',
  Delete: 'Eliminar',
  Cancel: 'Cancelar',
  OK: 'OK',
  'Factura-Openges': 'Factura Openges',
  cancelled: 'cancelado',
  'generated-pdf': 'PDF generado',
  draft: 'borrador',
  validated: 'validado',
  Name: 'Nombre',
  Password: 'Contraseña',
  'Confirm password': 'Confirmar contraseña',
  alta_trabajador: 'Alta trabajador',
  baja_trabajador: 'Baja trabajador',
  modificacion_contrato: 'Mod. Contrato',
  Save: 'Guardar',
  'Add new': 'Crear',
  Reset: 'Recargar',
  Search: 'Buscar',
  search: 'buscar',
};
